import { AxiosError } from 'axios';

/**
 * Достаёт человекочитаемое сообщение из ошибки axios/NestJS.
 * NestJS отдаёт `message` строкой (например, ConflictException) либо массивом
 * (валидация class-validator) — берём первый элемент.
 */
export function apiErrorMessage(e: unknown): string | undefined {
  const data = (e as AxiosError<{ message?: string | string[] }>)?.response?.data;
  const m = data?.message;
  if (Array.isArray(m)) return m[0];
  return typeof m === 'string' ? m : undefined;
}
